import React from "react";
import Wrapper from "../common/Wrapper";
import Header from "../common/Header";
import Empty from "../common/Empty";
import LessonForm from "../manage/LessonForm";
const ManageLessonPage = () => {
  return (
    <Wrapper>
      <Header />
      <Empty />
      <LessonForm />
      <Empty />
    </Wrapper>
  );
};

export default ManageLessonPage;
